export default __webpack_public_path__ + "static/smalls-default-9f66677fb33a257b6d8c18e5f5e235da.png";